/* licensingSettings.component.js */

import licensingSettingsController from "./licensingSettings.controller";

/**
 * @desc component for configuring Licensing settings for Integrations
 * @example <licensing-settings></licensing-settings>
 */

const licensingSettings = {
    bindings: {
        currentConfig: '<',
        originalConfig: '<',
        products: '<',
        updateConfiguration: '&'
    },
    controller: licensingSettingsController,
    controllerAs: 'lsvm',
    templateUrl: '/App/Components/configuration/licensingSettings/licensingSettings.tmpl.html'
};

export default licensingSettings;